module.exports = __webpack_public_path__ + "img/setting-2.bf5e3c66.svg";